.wishlistDelete {
  .button {
    width: 5.8125rem;
    height: 2.25rem;
    margin: 0.75rem 0 0;

    svg {
      width: 1.25rem;
      height: 1.25rem;
      color: var(--danger);
    }

    .buttonText {
      padding: 0 0.3125rem 0 0.375rem;
    }
  }
}
